<template>
    <div>
      <el-table ref="tableSort" :data="list" border>
        <el-table-column prop="name" show-overflow-tooltip label="系统" min-width="120" align="center"></el-table-column>
        <el-table-column prop="version_number" show-overflow-tooltip label="版本号" min-width="120" align="center"></el-table-column>
        <el-table-column prop="update_time" show-overflow-tooltip label="更新时间" min-width="120" align="center"></el-table-column>
        <el-table-column  label="操作面板" width="120px" align="center" fixed="right">
          <template #default="{ row }">
            <el-button type="text" @click="handleEdit(row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="500px"
        >
        <el-form ref="form" :model="form" label-width="100px">
          <el-form-item label="更新地址">
            <el-input v-model="form.address"></el-input>
          </el-form-item>
          <el-form-item label="版本号">
            <el-input v-model="form.version_number"></el-input>
          </el-form-item>
          <el-form-item label="是否强制更新">
            <el-radio-group v-model="form.edition_force">
              <el-radio :label="1">强制更新</el-radio>
              <el-radio :label="0">非强制更新</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否整包升级">
            <el-radio-group v-model="form.package_type">
              <el-radio :label="0">整包升级</el-radio>
              <el-radio :label="1">wgt更新</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="静默更新">
            <el-radio-group v-model="form.edition_silence">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="save">确 定</el-button>
        </span>
      </el-dialog>
    </div>
</template>

<script>
  import {
    Config_app_update,
    Config_app_list,
    Config_app_detail
  } from '@/api/xgcApi'
  export default {
    components: {},
    data() {
      return {
        list:[],
        form:{
          address:null, //apk、wgt包下载地址或者应用市场地址
          edition_force:null,//是否强制更新 0代表否 1代表是
          package_type:null,//0是整包升级（apk或者appstore或者安卓应用市场） 1是wgt升级
          version_number:null,//版本号
          edition_silence:null,//是否静默更新
        },
        dialogVisible:false
      }
    },
    beforeDestroy() {},
    mounted() {
      this.getList()
    },
    methods: {
      getList(){
        Config_app_list({}).then(res=>{
          this.list = res.data
        })
      },
      handleEdit(e){
        var data = {
          id:e.id
        }
        Config_app_detail(data).then(res=>{
          this.form = res.data
          this.dialogVisible = true
        })
      },
      save(){
        Config_app_update(this.form).then(res=>{
          this.$message({
            type:'success',
            message:'操作成功!'
          })
          this.dialogVisible = false
          this.getList()
        })
      }
    },
  }
</script>

<style>
</style>
